if (!window.YunaProductCardColours) {
  window.YunaProductCardColours = true;

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('.yn-card-colour-swatch');
    if (!swatch) return;

    const card = swatch.closest('[data-yuna-product-card]');
    if (!card) return;

    const image = card.querySelector('[data-yuna-card-image]');
    const productUrl = swatch.dataset.yunaColourUrl;
    const imageUrl = swatch.dataset.yunaColourImage;

    card.querySelectorAll('.yn-card-colour-swatch').forEach((option) => {
      const isSelected = option === swatch;
      option.classList.toggle('is-active', isSelected);
      option.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });

    if (image && imageUrl) {
      image.removeAttribute('srcset');
      image.src = imageUrl;
      image.alt = `${swatch.dataset.yunaColourName} press-on nails`;
    }

    if (productUrl) {
      card.querySelectorAll('a[href]').forEach((link) => {
        if (link.href.includes('/products/')) link.href = productUrl;
      });
    }
  });

  const initialiseWishlistButton = (wishlistButton) => {
    if (wishlistButton.dataset.yunaWishlistReady === 'true') return;
    wishlistButton.dataset.yunaWishlistReady = 'true';

    let attempts = 0;
    const connect = () => {
      const root = wishlistButton.shadowRoot;
      const button = root?.querySelector('button');

      if (!button) {
        attempts += 1;
        if (attempts < 120) requestAnimationFrame(connect);
        return;
      }

      const card = wishlistButton.closest('[data-yuna-product-card]');
      const addLabel = card?.dataset.yunaWishlistAdd;
      const removeLabel = card?.dataset.yunaWishlistRemove;
      if (!addLabel || !removeLabel) return;

      const syncState = () => {
        const currentLabel = button.getAttribute('aria-label') || '';
        const iconPath = root.querySelector('.Joy-Wishlist-WishlistButton__Icon path');
        const iconFill = iconPath?.getAttribute('fill');
        const isAdded =
          /added|remove/i.test(currentLabel) ||
          (iconFill && iconFill !== 'none' && iconFill !== 'transparent');
        const nextLabel = isAdded ? removeLabel : addLabel;

        wishlistButton.dataset.yunaWishlistState = isAdded ? 'added' : 'empty';
        if (button.getAttribute('aria-label') !== nextLabel) {
          button.setAttribute('aria-label', nextLabel);
        }

        const tooltip = root.querySelector('.Joy-Wishlist__Tooltip');
        if (tooltip && tooltip.textContent.trim() !== nextLabel) {
          tooltip.textContent = nextLabel;
        }
      };

      syncState();
      new MutationObserver(syncState).observe(root, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true,
      });
    };

    connect();
  };

  const initialiseWishlistButtons = (scope = document) => {
    scope.querySelectorAll('joy-wishlist-button[type="collection"]').forEach(initialiseWishlistButton);
  };

  initialiseWishlistButtons();
  new MutationObserver(() => initialiseWishlistButtons()).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
}
